import * as React from 'react';
import withSideEffect from 'react-side-effect';
import { disableBodyScroll, enableBodyScroll, } from '@core-front/helper';
const BodyScroll = (props) => {
    return React.createElement(React.Fragment, null, props.children);
};
function reducePropsToState(propsList) {
    return propsList.some((props) => props.isDisabled);
}
function handleStateChangeOnClient(isBodyScrollDisabled) {
    if (isBodyScrollDisabled) {
        disableBodyScroll();
    }
    else {
        enableBodyScroll();
    }
}
export default withSideEffect(reducePropsToState, handleStateChangeOnClient)(BodyScroll);
